exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-657233ba] .el-card__body{height:100%}[data-v-657233ba] .el-icon-arrow-right{display:none}[data-v-657233ba] .el-badge__content{top:10px}", ""]);

// exports
